import { render, staticRenderFns } from "./configuration-parameters-form.vue?vue&type=template&id=02c37642&scoped=true&"
import script from "./configuration-parameters-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-parameters-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-parameters-form.scss?vue&type=style&index=0&id=02c37642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c37642",
  null
  
)

export default component.exports